import { css, jsx } from '@emotion/react';
import { Colors, Icon } from '@zapier/design-system';
import React, { useContext } from 'react';
import { ComboBoxStateContext, Button } from 'react-aria-components';

const ComboBoxClearButtonStyles = css({
  display: "flex",
  padding: `var(--zds-space-8, 8px) var(--zds-space-4, 4px)`,
  fontSize: "0",
  background: `var(--zds-background-weaker, ${Colors.PrimeWhite})`,
  border: "none",
  borderRadius: `var(--zds-radius-default, 4px)`,
  cursor: "pointer",
  outline: "none",
  '&[data-size="compact"], &[data-size="medium"]': {
    padding: `var(--zds-space-4, 4px)`
  },
  "&[data-hovered] span": {
    fill: `var(--zds-text-weaker, ${Colors.GrayWarm9})`
  },
  "&[data-pressed] span": {
    fill: `var(--zds-text-default, ${Colors.GrayWarm10})`
  },
  "&[data-focus-visible] span": {
    borderRadius: "50%",
    outline: `2px solid var(--zds-ui-primary, ${Colors.UiPrimaryStrongest})`,
    outlineOffset: "-2px"
  }
});
const IconRightWrapperStyles = css({
  position: "absolute",
  top: 0,
  right: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: `var(--zds-size-40, 40px)`,
  height: `var(--zds-size-large, 44px)`,
  color: `var(--zds-stroke-stronger, ${Colors.GrayWarm6})`,
  '&[data-size="compact"], &[data-size="medium"]': {
    width: `var(--zds-size-medium, 36px)`,
    height: `var(--zds-size-medium, 36px)`
  }
});
const TypeaheadRightSlot = (props) => {
  const { iconRight, size } = props;
  const state = useContext(ComboBoxStateContext);
  const showClearSelectionButton = state === null || state === void 0 ? void 0 : state.inputValue;
  return jsx(React.Fragment, null, showClearSelectionButton ? jsx(
    "div",
    { css: IconRightWrapperStyles, "data-size": size, "data-zds": true },
    jsx(
      Button,
      {
        "aria-label": "Clear selection",
        css: ComboBoxClearButtonStyles,
        "data-size": size,
        "data-zds": true,
        onPress: () => state === null || state === void 0 ? void 0 : state.setSelectedKey(null),
        // Don't inherit default RAC Button behavior from RAC ComboBox.
        slot: null
      },
      jsx(Icon, { name: "formXCircle", color: "GrayWarm6", size: "24px" })
    )
  ) : iconRight && jsx(
    "div",
    { css: IconRightWrapperStyles, "data-size": size, "data-zds": true },
    jsx(Icon, { name: iconRight, size: "24px" })
  ));
};

export { TypeaheadRightSlot };
//# sourceMappingURL=TypeaheadRightSlot.es.js.map
